// @flow

import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { saveAs } from 'file-saver';

// redux
import { connect } from 'react-redux';
import { fetchSharedFileInfo, fetchSharedFile } from '../actions/shared';

import DocumentViewer from './document-viewer';
import Text from './shared/Typography';

import type { ResourceType, RecordFileType, SharedRecordFileType } from '../types/file';
import type { ShareStore } from '../types/shared';

type Props = {
  loadRecord: () => Promise<RecordFileType>,
  loadDocument: () => Promise<*>,
  children?: any,
  onExit: () => void,
  token: string,
  id: Number,
  shared_at: string,
  user: string,
  file: ShareStore,
  doc: ShareStore,
  location: Object,
  history: {
    goBack: () => void
  },
  getFile: (token: string, accessToken: string, recordID: Number, fileID: Number) => ShareStore,
  getDoc: (token: string, accessToken: string, recordID: Number, fileID: Number) => ShareStore,
  sharedRecord: ResourceType,
  match?: Object,
  getSharedFile?: any,
  getSharedDoc?: any
} & WithTranslation

type State = {
  blob?: Blob,
  pdfSrc?: string,
  imgSrc?: string,
  text?: string,
  file?: RecordFileType | SharedRecordFileType,
  blob?: Blob,
  error: string,
  loading: boolean
}

type documentField = 'pdfSrc' | 'imgSrc' | 'text';

const mapStateToProps = (appState) => ({
  // for shared records
  file: appState.sharedFileInfo,
  doc: appState.sharedFileView,
  sharedRecord: appState.sharedSingleRecord
  && appState.sharedSingleRecord.data
  && appState.sharedSingleRecord.data.record
});

const mapDispatchToProps = (dispatch) => ({
  getSharedFile: ((token, accessToken, recordID, fileID) =>
    dispatch(fetchSharedFileInfo(token, accessToken, recordID, fileID))),
  getSharedDoc: ((token, accessToken, recordID, fileID) =>
    dispatch(fetchSharedFile(token, accessToken, recordID, fileID)))
});

class ResourceViewer extends Component {
  state: State = {
    blob: Blob,
    error: '',
    file: {},
    imgSrc: '',
    loading: false,
    pdfSrc: '',
    text: ''
  };

  handleDocumentFormat(file, blob: Blob): Promise<{ [documentField]: string }> {
    return new Promise((resolve, reject) => {
      if (file.mime_type && file.mime_type.indexOf('pdf') > -1) {
        resolve({ pdfSrc: window.URL.createObjectURL(blob) });
      } else if (file.mime_type && file.mime_type.indexOf('image') > -1) {
        resolve({ imgSrc: window.URL.createObjectURL(blob) });
      } else if (file.mime_type && file.mime_type.indexOf('text') > -1) {
        const fileReader: FileReader = new FileReader();
        fileReader.onloadend = () => resolve({ text: fileReader.result });
        fileReader.readAsText(blob);
      } else {
        reject();
      }
    });
  }

  handleDocFormatFn = (file, blob: Blob) => (
    this.handleDocumentFormat(file, blob).then((subState: { [documentField]: string }) => {
      this.setState({
        loading: false,
        file,
        blob,
        ...subState
      });
    })
  )

  catchError = (error) => this.setState({
    loading: false,
    error: error === 'Access Denied' ? this.props.t('access_denied') : this.props.t('default_error')
  })

  download = (): void => {
    if (this.state.blob && this.state.file) {
      saveAs(this.state.blob, this.state.file.file_name);
    }
  }

  componentDidUpdate(prevProps) {
    // for shared docs
    const { file, doc } = this.props;
    if ((doc && doc.error) || (file && file.error)) this.catchError(file.error || doc.error);
    if ((doc && doc.data !== prevProps.doc.data)) {
      this.handleDocFormatFn(file.data, doc.data);
    }
  }

  componentWillMount() {
    const { match, getSharedFile, getSharedDoc, loadRecord, loadDocument } = this.props;
    if (match && match.params && match.params.token) {
      const { token, fileID, id } = match && match.params;
      // for shared documents
      getSharedFile(token, id, fileID);
      getSharedDoc(token, id, fileID);
    } else {
      // for regular documents
      loadRecord()
        .then((regularFile: RecordFileType) => {
          loadDocument()
            .then((blob: Blob) => {
              this.handleDocFormatFn(regularFile, blob);
              return null;
            });
        }).catch((error) => this.catchError(error));
    }
  }

  props: Props;

  render() {
    const sharedRecord = this.props.match && this.props.match.params && this.props.match.params.token;

    const buttonPress = sharedRecord ? this.props.history && this.props.history.goBack : this.props.onExit;
    return (
      <div className='pdf-viewer'>
        <header>
          <div className='title'>
            <h2 className='is-white'>{this.state.file ? this.state.file.file_name : '' }</h2>
          </div>
          <div className='options'>
            <div
              className='delete is-large'
              onClick={buttonPress}
              role='button'
              tabIndex={0}
            />
          </div>
        </header>
        {(!this.state.error && this.state.loading)
          && <div className='spinner is-background' />}
        {this.state.error &&
          <div>
            <Text h2 className='is-subtitle' align='center'>{this.state.error}</Text>
          </div>}
        <DocumentViewer
          record={this.state.file}
          imgSrc={this.state.imgSrc}
          pdfSrc={this.state.pdfSrc}
          text={this.state.text}
          onDownload={this.download}
        />
      </div>
    );
  }
}


export default withTranslation('resourceViewer')(
  connect(mapStateToProps, mapDispatchToProps)(ResourceViewer)
);



// WEBPACK FOOTER //
// ./src/components/resource-viewer.js